import { Spacer } from "@aircall/tractor";

import { RenderMultipleProps } from "./RenderMultiple.decl";

export function RenderMultiple({
  children,
  quantity,
  ...spaceProps
}: RenderMultipleProps) {
  const items = Array(quantity).fill(undefined);

  return (
    <Spacer {...spaceProps}>{items.map((_, index) => children(index))}</Spacer>
  );
}
